import styled, { css } from 'styled-components'
import Flex from 'Components/Flex'


import {
  BREAK_POINT_MD, BREAK_POINT_SM, BREAK_POINT_LG,
} from '@CSSVars/variables'

import {
  LIGHT_BACKGROUND, OUTLINE_COLOR, SELECTED_ITEM_BG_COLOR,
  CLICKABLE_COLOR, MARKER_COLOR, TEXT_GREY, FONT_BASE_COLOR, GREY_BACKGROUND,
  SURFACE_SECONDARY,
} from '@CSSVars/colors'

export const _NearbyCss = css`
  width: 100%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  text-decoration: none;
  color: ${FONT_BASE_COLOR};
  border-radius: 10px;

  @media (hover: hover){
    &:hover{
      color:${CLICKABLE_COLOR};
      cursor: pointer;
    }
  }
  &:active{
    color: ${SELECTED_ITEM_BG_COLOR};
  }

`

export const _NearbyCta = styled.div`
    ${_NearbyCss};
    height: 44px;
    border: 1px solid ${OUTLINE_COLOR};
  @media screen and (max-width: ${BREAK_POINT_SM}) {
   ${({ inBaloonTable }) => (inBaloonTable && `
   border-radius: 0;
   border-bottom: none;
   border-left: none;
   border-right: none;
   `)}
  }

`

export const _NearbyCtaMobile = styled.div`
  ${_NearbyCss};
  height: 36px;
  position: absolute;
  bottom: 17px;
  left: 50%;
  transform:translateX(-50%);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  width: 60%;
  color: ${FONT_BASE_COLOR};
  @media screen and (min-width: ${BREAK_POINT_MD}) {
    display: none;
  }

`

export const _ExpandBtn = styled.div`
  width: 44px;
  height: 44px;
  position: absolute;
  top: 12px;
  right: 12px;
  border-radius: 10px;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  cursor: pointer;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
  &:hover {
    background: ${GREY_BACKGROUND};
  }
  &:active {
    background: ${SELECTED_ITEM_BG_COLOR};
    svg {
      path {
        stroke: white;
      }
    }
  }

`

export const _Selected = css`
  opacity: ${({ isSelected }) => (isSelected ?
    '1' : '0.6')};

`

export const _NearbyMapIntro = styled.div`
background-color: ${SURFACE_SECONDARY};
  width: 100%;
  display: flex;
  justify-content: center;
  height: ${({ desktopView, isMapOnlyView }) => (desktopView ?
    '376px' : isMapOnlyView ? '160px' : '274px')};
  margin: auto;
  position: relative;
  border-radius: ${({ isMapOnlyView }) => (!isMapOnlyView ?
    '0' : '15px')};
  overflow: hidden;

  ${({ isMapOnlyView, desktopView }) => (isMapOnlyView ? `
    cursor: pointer;
    div {
      pointer-events: none;
    }
    background-color: grey;
      & ${_NearbyCta} {
        width: auto;
        padding: 0 10px;
        left: 50%;
        transform: translateX(-50%);
        bottom: 20px;
        color: inherit;
        text-decoration: none;
      }

      ` : desktopView ? `
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      ` : 'display: none;')};
`

export const _SpinnerContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  pointer-events: none;
`

export const _MapOnlyViewCaption = styled.div`
  font-size: 12px;
  line-height: 16px;
  margin-top: 10px;
  color: ${TEXT_GREY};
`

export const _MobileBaloonsTitle = styled.h3`
  display: none;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: block;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    margin-top: 24px;
    margin-bottom: 8px;
  }
`


export const _PlaceBaloons = styled(Flex)`
  width: 100%;
  height: 94px;
  padding: 0 20px;
  background-color: ${LIGHT_BACKGROUND};
  z-index: 100;
  svg {
    margin-right: 12px;
    fill: transparent;
  }

  .cls-1 {
    fill: ${MARKER_COLOR};
  }

  ${({ isCondos }) => (isCondos ? `
    .cls-1 {
      fill: #90D4D4;
    }
    ` : `
    .cls-2 {
      fill: white;
    }
    .cls-stroke {
      stroke: white;
    }
    `)};

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    height: 234px;
    flex-direction: column;
    align-items: flex-start;
  }
`

export const _PlaceInfoMobile = styled(Flex)`
    div {
      font-size: 16px;
    }

`

export const _PlaceInfo = styled(Flex)`
  svg {
    fill: transparent;
    path, circle {
      stroke: ${CLICKABLE_COLOR};
    }
    stroke: ${CLICKABLE_COLOR};
  }
  ${({ isCondos }) => (isCondos ? `
    .cls-1 {
      fill: #90D4D4;
    }
    ` : `
    .cls-2 {
      fill: white;
    }
    .cls-stroke {
      stroke: white;
    }
    `)};
    ${({ restaurentMarker }) => (restaurentMarker ? `
    svg {
      path:last-child {
        fill: ${CLICKABLE_COLOR};
      }
    }
  }` : '')};

  margin-right: 24px;
  ${_Selected};
  cursor: pointer;
  &:hover {
    opacity: 1 !important;
  }
  @media screen and (min-width: ${BREAK_POINT_MD}) and (max-width: ${BREAK_POINT_LG}) {
   margin-right: 12px;

  }
`

export const _PlaceCount = styled(Flex)`
  font-weight: 600;
  font-size: 12px;
  line-height: 22px;
  color: ${CLICKABLE_COLOR};
  margin-left: 10px;
`

export const _PlaceTitle = styled(Flex)`
  font-size: 12px;
  color: ${CLICKABLE_COLOR};
`
export const _DesktopPlaceTitle = styled(Flex)`
  font-size: 12px;
  font-weight: 500;
  color: ${FONT_BASE_COLOR};
  white-space: nowrap;
`

export const _NearbyCtaTable = styled.div`
  background: ${GREY_BACKGROUND};
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  display: none;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: flex;
    flex-direction: column;
  }
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    border: 1px solid ${OUTLINE_COLOR};
    border-radius: 10px;
    overflow: hidden;
    display: flex;
  }
`
export const _FloatingBaloons = styled.div`
  width: calc(100% - 106px);
  height: 44px;
  border-radius: 10px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
  position: absolute;
  bottom: 12px;
  background: white;
  z-index: 100;
  display: flex;
  justify-content: center;
  flex-direction: row;
  padding-left: 12px;
  ${({ isSelected }) => (!isSelected ? `
      >div {
        opacity: 1; !important
      }
    ` : `
    `)};
  &:hover {
    >div {
      opacity: 0.6;
    }
  }
  @media screen and (min-width: ${BREAK_POINT_MD}) and (max-width: ${BREAK_POINT_LG}) {
    width: fit-content;
    max-width: calc(100% - 24px);

  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: none;

  }
`
